<script lang="ts" setup>
import { defineProps,ref } from 'vue';
import { useLocaleStore } from '../../../stores/locale';
import { useI18n } from 'vue-i18n';

const t = useI18n().t;

defineProps({
    title: {
        type: String,
        default: 'Footer',
    },
    phone: {
        type: String,
        default: '+44 208 068 2811',
    },
    mobile: {
        type: String,
        default: '+44 208 068 2811',
    },
    address: {
        type: String,
        default: 'London, UK',
    },
    instagram: {
        type: String,
        default: 'https://www.instagram.com/',
    },
    youtube: {
        type: String,
        default: 'https://www.youtube.com/',
    },
    linkedin: {
        type: String,
        default: 'https://www.linkedin.com/',
    },
    facebook: {
        type: String,
        default: 'https://www.facebook.com/',
    },
    twitter: {
        type: String,
        default: 'https://twitter.com/',
    },
    whatsapp: {
        type: String,
        default: 'https://wa.me/',
    },
});
const localeStore = useLocaleStore();

const corp_info = ref({
    name: '',
    address: '',
    phone: '',
    mobile: '',
    email: '',
    description: '',
    logo: '',
});
corp_info.value = JSON.parse(localStorage.getItem('corp') || '{}');
</script>
<template>
    <footer class="gap no-bottom three" style="background-image: url(../../../../../assets/img/footer.jpg);"
        :dir="localeStore.locale === 'ar' ? 'rtl' : 'ltr'">
        <div class="container">
            <div class="row position-relative footer-boder">
                <div class="col-lg-3">
                    <div class="logo">
                        <router-link :to="'/'"><img v-if="corp_info.logo" :src="corp_info.logo ?? '../../../assets/img/logo.png'" alt="cubic"
                                width="250"></router-link>
                    </div>
                </div>
                <div class="col-lg-9">
                    <div class="logo-heading text-center d-flex items-center justify-content-center">
                        <p>{{ t('Building your own home is about desire, fantasy. But it’s achievable anyone can do it')
                        }}.</p>
                    </div>
                </div>
                <!-- <div class="col-lg-3">
                    <div class="footer-btn">
                        <a href="#" class="theme-btn w-color">{{ t('Subscribe Newsletter') }}</a>
                    </div>
                </div> -->
            </div>
            <div class="row">
                <div class="col-lg-3 col-md-6">
                    <div class="footer-contact">
                        <h3>{{ t('Contact Us') }}</h3>
                        <a href="#"><span>P:</span> {{ phone }}</a>
                        <a href="#"><span>M:</span> {{ mobile }}</a>
                        <div class="img-slider swiper">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide">
                                    <img src="../../../assets/img/hero-three-1.jpg" alt="img">
                                </div>
                                <div class="swiper-slide">
                                    <img src="../../../assets/img/hero-three-2.jpg" alt="img">
                                </div>
                                <div class="swiper-slide">
                                    <img src="../../../assets/img/hero-three-3.jpg" alt="img">
                                </div>
                            </div>
                            <div class="swiper-pagination"></div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="footer-contact widget-title">
                        <h3>
                            {{ t('Quick Links') }}
                        </h3>
                        <ul>
                            <!-- <li><i class="fa-solid fa-caret-right"></i><a href="/about">{{t('About')}} </a></li> -->
                            <!-- <li><i class="fa-solid fa-caret-right"></i><a href="#">Team </a></li>
                            <li><i class="fa-solid fa-caret-right"></i><a href="#">Testimonials </a></li>
                            <li><i class="fa-solid fa-caret-right"></i><a href="#">Blog Grid </a></li>
                            <li><i class="fa-solid fa-caret-right"></i><a href="#">News </a></li> -->
                            <li><i class="fa-solid fa-caret-right"></i><a href="/#design-your">{{t('Contact Us')}}</a></li>
                            <li><i class="fa-solid fa-caret-right"></i><a href="/projects">{{t('Projects')}}</a></li>
                            <!-- <li><i class="fa-solid fa-caret-right"></i><a href="#">Team </a></li> -->
                            <li><i class="fa-solid fa-caret-right"></i><a href="/about">{{t('About Us')}}</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="footer-contact footer_widget_title">
                        <h3>{{ t('Our Addresses') }}</h3>
                        <div class="location">
                            <div><i class="flaticon-map-location"></i></div>
                            <div class="location-style">
                                <h6>{{ t('Head Office') }}</h6>
                                <p>{{ address }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="footer-contact">
                        <h3>{{ t('Follow Us') }}</h3>
                        <ul class="footer-social-media">
                            <li><a :href="instagram"><i class="fa-brands fa-instagram"></i>{{ t('Instagram') }}</a>
                            </li>
                            <li><a :href="youtube"><i class="fa-brands fa-youtube"></i>{{ t('Youtube') }}</a></li>
                            <li><a :href="linkedin"><i class="fa-brands fa-linkedin-in"></i>{{ t('LinkedIn') }}</a>
                            </li>
                            <li><a :href="facebook"><i class="fa-brands fa-facebook-f"></i>{{ t('Facebook') }}</a></li>
                            <li><a :href="twitter"><i class="fa-brands fa-twitter"></i>{{ t('Twitter') }}</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="f-bottom">
                <p>© Copyright 2025. All Rights Reserved by <a href="https://smartsware.com" target="_blank">
                        smartsware.com</a></p>
                <ul>
                    <!-- <li>
                        <a href="#">Sitemap</a>
                    </li> -->
                    <li>
                        <a href="/#design-your">{{t('Contact Us')}}</a>
                    </li>
                    <!-- <li>
                        <a href="#">Privacy Policy</a>
                    </li> -->
                </ul>
            </div>
        </div>
    </footer>
</template>



<style lang="scss" scoped></style>